var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPayServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 57,
    viewBox: "0 0 85 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2040_665)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.25488,
    y: 0.419922,
    width: 73.01,
    height: 41.7206,
    fill: "#00B25C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.38184,
    y: 0.419922,
    width: 23.4675,
    height: 41.7206,
    fill: "#84DEB3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7373,
    y: 5.63477,
    width: 44.3275,
    height: 31.2904,
    fill: "#84DEB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.441 21.0264L13.9223 19.0264H13.2598V18.4951H13.7848L13.266 16.5013H13.9348L14.4098 18.4951H15.2098L15.7098 16.5013H16.3973L16.8973 18.4951H17.6973L18.1723 16.5013H18.841L18.3223 18.4951H18.8473V19.0264H18.1848L17.6598 21.0264H16.9723L16.4535 19.0264H15.6535L15.1348 21.0264H14.441ZM14.541 19.0264L14.7785 20.0326H14.8223L15.0785 19.0264H14.541ZM15.7973 18.4951H16.316L16.0723 17.5638H16.0348L15.7973 18.4951ZM17.0348 19.0264L17.2848 20.0389H17.3223L17.566 19.0264H17.0348Z",
    fill: "#00C968"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.73535,
    y: 10.8213,
    width: 70.4025,
    height: 41.7206,
    fill: "#00C968"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.73535,
    y: 10.8594,
    width: 23.4675,
    height: 41.7206,
    fill: "#A4EECB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.1875,
    y: 16.0752,
    width: 41.72,
    height: 31.2904,
    fill: "#A4EECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83186 46.1094L8.2756 40.1093H6.28809V38.5156H7.8631L6.30684 32.5343H8.3131L9.73811 38.5156H12.1381L13.6381 32.5343H15.7006L17.2006 38.5156H19.6007L21.0257 32.5343H23.0319L21.4757 38.5156H23.0507V40.1093H21.0632L19.4882 46.1094H17.4256L15.8694 40.1093H13.4694L11.9131 46.1094H9.83186ZM10.1319 40.1093L10.8444 43.1281H10.9756L11.7444 40.1093H10.1319ZM13.9006 38.5156H15.4569L14.7256 35.7218H14.6131L13.9006 38.5156ZM17.6131 40.1093L18.3631 43.1469H18.4757L19.2069 40.1093H17.6131Z",
    fill: "#00C968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2040_665",
    x: 0.735352,
    y: 0.419922,
    width: 83.5293,
    height: 56.1602,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2040_665"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2040_665",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPayServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcPayServiceMainMobile.b25e5d3d548a4da71d396db6747b7281.svg";
export { ForwardRef as ReactComponent };